import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsFileText, BsXLg } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import TextInput from '#globalComponents/Forms/TextInput';
import IconButton from '#globalComponents/IconButton/IconButton';
import { useErrorStore } from '#lib/stores/errorStore';

import { useCreateActivity, useUpdateActivity } from '../../../../models/activities/mutations';
import NoteEditor from '../NoteEditor';

const NoteForm = ({ companyId, dealId, onClose, initialData }) => {
	const isEdit = Boolean(initialData);
	const [title, setTitle] = useState(initialData?.title ?? '');
	const [body, setBody] = useState(initialData?.body ?? '');
	const createActivity = useCreateActivity();
	const updateActivity = useUpdateActivity();
	const showError = useErrorStore((s) => s.showError);

	const handleSubmit = async () => {
		if (!body.trim() && !title.trim()) return;
		try {
			if (isEdit) {
				await updateActivity.mutateAsync({
					id: initialData.id,
					payload: { title: title.trim() || 'Notiz', body },
				});
			} else {
				await createActivity.mutateAsync({
					crmCompanyId: companyId,
					...(dealId && { dealId }),
					activityType: 'note',
					title: title.trim() || 'Notiz',
					body,
					status: 'completed',
					completedAt: new Date().toISOString(),
				});
			}
			onClose();
		} catch (err) {
			showError({ error: err, title: isEdit ? 'Speichern fehlgeschlagen' : 'Fehler beim Speichern' });
		}
	};

	const isPending = isEdit ? updateActivity.isPending : createActivity.isPending;

	return (
		<div className="p-3 space-y-2">
			<div className="flex items-center gap-2">
				<div className="flex items-center gap-1.5 px-2 py-1 rounded-control bg-primary-100 text-primary-600 text-xs font-medium">
					<BsFileText className="w-4 h-4" /> Notiz
				</div>
				<IconButton icon={BsXLg} label="Schließen" onClick={onClose} className="ml-auto h-6 w-6" />
			</div>
			<TextInput value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Notiz-Titel …" autoFocus />
			<NoteEditor value={body} onChange={setBody} />
			<div className="flex justify-end gap-2 pt-1">
				<Button type="button" variant="outline" size="sm" onClick={onClose}>
					Abbrechen
				</Button>
				<Button
					variant="solid"
					size="sm"
					onClick={handleSubmit}
					loading={isPending}
					disabled={!body.trim() && !title.trim()}
				>
					Speichern
				</Button>
			</div>
		</div>
	);
};
NoteForm.propTypes = {
	companyId: PropTypes.string,
	dealId: PropTypes.string,
	onClose: PropTypes.func,
	initialData: PropTypes.object,
};

export default NoteForm;
